export const API_URL =
  process.env.NODE_ENV === 'development' ? 'http://localhost:3001/api' : window.location.origin + '/api';

export const API_KEY = 'XDea6wxZG55u';

export const AMPLITUDE_API_KEY = '51e0b8604fdc0f1008108317a30d3512';

export const API_UPLOAD_URL = API_URL + '/assets/upload';

export const AI_API_URL =
  process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://mintai.tangerine-dev1.oneclicklabs.es';

export const TANGERINE_AI_API_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000/api/v1'
    : 'https://api-ai.tenant-ai-1.oneclicklabs.es/ai/v1';

export const TANGERINE_AI_API_KEY = '65a638c3-c900-4001-bb2f-efca000ecf22';
